module.exports = __webpack_public_path__ + "img/t.5344d760.jpg";